import Api from "@/inc/Api";

export const QuestionsGroupApi = async () => {
    // Simulate an API call to fetch class data
    let api = Api;
    api.setUserToken();
    const response = await api.axios().get('/interested-question/group/list');
    return response.data.type ? response.data.data : [];
}